export function menuItemReducer ( state = '', action ){
    switch( action.type ){
        case "SET_MEU_ITEM_ACTIVE":
            return action.payload
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/components/theme/sidebar/Menu/reducers.js